import { useStaticImagePreloader } from "@/hooks/staticImagePreloader";

type StaticMenuProps = {
  brand: string;
};

export const StaticMenu = ({ brand }: StaticMenuProps) => {
  if (brand == "unknown") {
    return (
      <div
        style={{
          flex: 1,
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <h1>Whoops! Nothing is here</h1>
      </div>
    );
  }
  document.documentElement.classList.add(brand);
  const { data: staticImages } = useStaticImagePreloader(brand);

  return (
    <div>
      {staticImages?.map((img, idx) => (
        <img
          key={idx}
          loading="lazy"
          className="w-full h-auto"
          width="2000"
          height="3800"
          src={img}
          fetchPriority={idx === 0 ? "high" : "low"}
        ></img>
      ))}
    </div>
  );
};
